<template>
    <Swiper class="home-intro-carousel h-full max-h-full" v-bind="carouselConfig">
        <SwiperSlide v-for="(item, index) in items" :key="item.image.id" class="relative" :lazy="index !== 0">
            <img
                :src="item.image.url"
                :srcset="`${item.image.preview} 300w, ${item.image.url} ${item.image.width}w`"
                sizes="(max-width: 768px) 100vw, 50vw"
                :width="item.image.width"
                :height="item.image.height"
                :alt="item.image.alt"
                class="block size-full object-cover"
                :loading="index === 0 ? 'eager' : 'lazy'"
                :fetchpriority="index === 0 ? 'high' : undefined"
            />

            <div class="absolute right-5.25 bottom-4">
                <UiButton :href="`/restaurants/${item.conceptObj.slug}`">{{ item.conceptObj.name }}</UiButton>
            </div>
        </SwiperSlide>

        <template #container-start>
            <button type="button" class="carousel-nav carousel-nav-prev">
                <ArrowRightIcon class="size-5 rotate-180" />
                <span class="sr-only">Previous carousel slide</span>
            </button>
            <button type="button" class="carousel-nav carousel-nav-next">
                <ArrowRightIcon class="size-5" />
                <span class="sr-only">Next carousel slide</span>
            </button>
        </template>
    </Swiper>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay } from 'swiper/modules';
import UiButton from '../Ui/UiButton.vue';
import ArrowRightIcon from '../../../images/icons/arrow-right.svg';
import { useCarousel } from '../../composables/carousel';

defineProps({ items: { type: Array, required: true } });

const { standardCarouselConfig } = useCarousel(false);

const carouselConfig = {
    ...standardCarouselConfig,
    lazy: true,
    lazyPreloadPrevNext: 1,
    modules: [...standardCarouselConfig.modules, Autoplay],
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
};
</script>
